import React from "react";
import "./Documentaries.css";

import img1 from "../../assets/Blaandor/Copy of Copy of Screenshot (110).jpg";
import img2 from "../../assets/Blaandor/Copy of Copy of Screenshot (137).jpg";
import img3 from "../../assets/Blaandor/Copy of Copy of Screenshot (127).jpg";
import img4 from "../../assets/Blaandor/Copy of BALANOOR DOCUMENTARY.jpg";
import img5 from "../../assets/Blaandor/Copy of Screenshot (134).jpg";
import img6 from "../../assets/Blaandor/Copy of DSC03946.jpg";
import img7 from "../../assets/Blaandor/Copy of Copy of Screenshot (126).jpg";

const documentaryGroups = [
  {
    title: "BALANOOR PLANTATIONS",

    description:
      "Exploring the craft, care, and legacy behind speciality coffee.",

    note:
      "I came for the shoot. I left with expensive coffee habits.",

    eyebrow: "COFFEE • CRAFT • LEGACY",

    items: [
      { image: img1 },
      { image: img2 },
      { image: img3 },
      { image: img4 },
      { image: img5 },
      { image: img6 },
      { image: img7 },
    ],
  },
];

const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "EVENTS",
  "PODCASTS & INTERVIEWS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
  
];

function goToSlug(category) {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, "-");
}

function Documentaries() {
  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};

  return (
    <main className="documentaries-page">

      <div className="documentaries-shell">

        {/* HEADER */}

        <header className="documentaries-main-header">

          <div className="documentaries-eyebrow">
            <span></span>
            THE DOCUMENTARY ARCHIVE
            <span></span>
          </div>

          <h1 className="documentaries-main-title">
            DOCUMENTARIES
          </h1>

          <div className="documentaries-main-rule">
            <span>REAL STORIES • REAL PEOPLE • REAL PLACES</span>
          </div>

        </header>


        {/* CONTENT */}

        <div className="documentaries-content">

          {documentaryGroups.map((group, groupIndex) => (

            <section
              className="documentary-group"
              key={group.title}
            >

              {/* PROJECT INTRO */}

              <div className="documentary-intro">

                <div className="documentary-project-meta">

                  <span className="documentary-number">
                    0{groupIndex + 1}
                  </span>

                  <span className="documentary-eyebrow-small">
                    {group.eyebrow}
                  </span>

                </div>


                <div className="documentary-heading">

                  <div className="documentary-heading-title">

                    <span>DOCUMENTARY</span>

                    <h2>
                      {group.title}
                    </h2>

                  </div>

                  <div className="documentary-heading-line"></div>

                </div>


                <div className="documentary-description-wrap">

                  <p className="documentary-description">
                    {group.description}
                  </p>

                  <p className="documentary-note">
                    {group.note}
                  </p>

                </div>

              </div>


              {/* CINEMATIC COLLAGE */}

             <div className="documentary-collage">

  {/* TOP LEFT */}
  <div className="documentary-image documentary-image-1">
    <img src={img1} alt="Balanoor landscape" />
  </div>

  {/* TOP CENTER */}
  <div className="documentary-image documentary-image-2">
    <img src={img2} alt="Balanoor people" />
  </div>

  {/* TOP RIGHT */}
  <div className="documentary-image documentary-image-3">
    <img src={img3} alt="Balanoor plantation aerial view" />
  </div>


  {/* MAIN BANNER */}
  <div className="documentary-image documentary-image-4">

    <img
      src={img4}
      alt="Balanoor documentary"
    />

    <div className="documentary-banner-title">
      BALANOOR
    </div>

  </div>


  {/* BOTTOM LEFT */}
  <div className="documentary-image documentary-image-5">
    <img src={img5} alt="Balanoor community" />
  </div>

  {/* BOTTOM CENTER */}
  <div className="documentary-image documentary-image-6">
    <img src={img6} alt="Balanoor coffee" />
  </div>

  {/* BOTTOM RIGHT */}
  <div className="documentary-image documentary-image-7">
    <img src={img7} alt="Balanoor plantation worker" />
  </div>

</div>


              {/* PROJECT FOOTER */}

              <div className="documentary-project-footer">

                <span>
                  BALANOOR / INDIA
                </span>

                <span>
                  DOCUMENTARY FILM
                </span>

                <span>
                  07 FRAMES
                </span>

              </div>

            </section>

          ))}

        </div>


        {/* CATEGORY NAV */}

        <nav className="documentaries-category-bar">

          <button
            className="documentaries-nav-arrow"
            onClick={() =>
              goToCategory("CORPORATE FILMS")
            }
            aria-label="Previous category"
          >
            ←
          </button>


          <div className="documentaries-category-list">

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`documentaries-category ${
                  category === "DOCUMENTARIES"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          <button
            className="documentaries-nav-arrow"
            onClick={() =>
              goToCategory("EVENTS")
            }
            aria-label="Next category"
          >
            →
          </button>

        </nav>

      </div>

    </main>
  );
}

export default Documentaries;